export const T = {
  en_GB: {
    productRegister: "Product Register",
    description: "Centralized list of products that can be used across multiple portfolios",
    addProduct: "Add Product",
    loadCsv: "Load CSV",
    searchPlaceholder: "Search",
    deleteProduct: "Delete Product",
    deleteConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    productDeleted: "Product deleted successfully",
    error: "Error",
    failedToDelete: "Failed to delete product",
    failedToLoad: "Failed to load product",
  },
  nb_NO: {
    productRegister: "Produktregister",
    description: "Sentralisert liste over produkter som kan brukes på tvers av flere porteføljer",
    addProduct: "Legg til produkt",
    loadCsv: "Last inn CSV",
    searchPlaceholder: "Søk",
    deleteProduct: "Slett produkt",
    deleteConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    productDeleted: "Produkt slettet",
    error: "Feil",
    failedToDelete: "Kunne ikke slette produkt",
    failedToLoad: "Kunne ikke laste produkt",
  },
} as const;
